var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgArrowsDirections(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M13.2 9.6h1.2v18c0 .22.18.4.4.4h2.4a.4.4 0 00.4-.4v-18h1.2a.4.4 0 00.346-.602l-2.8-4.8a.4.4 0 00-.692 0l-2.8 4.8a.4.4 0 00.346.602zM16 5.194L18.104 8.8H17.2a.4.4 0 00-.4.4v18h-1.6v-18a.4.4 0 00-.4-.4h-.904L16 5.194z"
  }), React.createElement("path", {
    d: "M18.4 14.8v12.8c0 .22.18.4.4.4h2.4a.4.4 0 00.4-.4V16h.8v1.2a.4.4 0 00.602.345l4.8-2.8a.4.4 0 000-.69l-4.8-2.8a.4.4 0 00-.602.345v1.2h-2a2.002 2.002 0 00-2 2zm.8 0c0-.662.538-1.2 1.2-1.2h2.4a.4.4 0 00.4-.4v-.904l3.606 2.104-3.606 2.104V15.6a.4.4 0 00-.4-.4h-1.6a.4.4 0 00-.4.4v11.6h-1.6V14.8zM4.198 21.145l4.8 2.8A.4.4 0 009.6 23.6v-1.2h.8v5.2c0 .22.18.4.4.4h2.4a.4.4 0 00.4-.4v-6.4a2.002 2.002 0 00-2-2h-2V18a.4.4 0 00-.602-.346l-4.8 2.8a.4.4 0 000 .691zM8.8 18.696v.904c0 .22.18.4.4.4h2.4c.662 0 1.2.538 1.2 1.2v6h-1.6V22a.4.4 0 00-.4-.4H9.2a.4.4 0 00-.4.4v.904L5.194 20.8 8.8 18.696z"
  })));
}

export default SvgArrowsDirections;